import React from "react";

interface RefreshIconProps {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  color?: string;
}

const RefreshIcon: React.FC<RefreshIconProps> = ({ 
  width = 18, 
  height = 18, 
  style,
  color = "currentColor" 
}) => (
  <svg 
    width={width} 
    height={height} 
    style={style} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={color} 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
    <path d="M16 16h5v5" />
  </svg>
);

export default RefreshIcon;
